export const openfinanceProviders = [
  {
    providerFriendlyId: "yahav-sandbox",
    name: "Yahav Sandbox",
    nameNativeLanguage: "יהב סנדבוקס",
    mode: "PSD2",
    site: "www.bank-yahav.co.il",
    image:
      "https://open-finance-assets.s3.eu-west-1.amazonaws.com/providers-logos/yahav.jpeg",
    isFake: "true",
    psd2Uris: {
      cardUri: "https://testapifin.yahav.co.il/v1.7.0",
      loanUri: "https://testapifin.yahav.co.il/v1.4.0",
      savingsUri: "https://testapifin.yahav.co.il/v1.4.0",
      securitiesUri: "https://testapifin.yahav.co.il/v1.0.0",
      tokenUri: "https://testapifin.yahav.co.il:443/oauth/token",
      baseUri: "https://testapifin.yahav.co.il/v1.7.0",
    },
    type: "BANK",
    status: {
      consents: {
        enabled: true,
      },
      payments: {
        enabled: true,
      },
    },
    successRate: {
      consents: 100,
      payments: 100,
    },
  },
  {
    providerFriendlyId: "yahav",
    name: "Yahav",
    nameNativeLanguage: "יהב",
    mode: "PSD2",
    site: "www.bank-yahav.co.il",
    image:
      "https://open-finance-assets.s3.eu-west-1.amazonaws.com/providers-logos/yahav.jpeg",
    psd2Uris: {
      cardUri: "https://apifin.yahav.co.il/v1.7.0",
      loanUri: "https://apifin.yahav.co.il/v1.4.0",
      savingsUri: "https://apifin.yahav.co.il/v1.4.0",
      securitiesUri: "https://apifin.yahav.co.il/v1.0.0",
      tokenUri: "https://apifin.yahav.co.il/oauth/token",
      baseUri: "https://apifin.yahav.co.il/v1.7.0",
    },
    type: "BANK",
    status: {
      consents: {
        enabled: true,
      },
      payments: {
        enabled: true,
      },
    },
    successRate: {
      consents: 100,
      payments: 100,
    },
  },
  {
    providerFriendlyId: "undefined",
  },
  {
    providerFriendlyId: "ubank-sandbox",
    name: "U-Bank Sandbox",
    nameNativeLanguage: "U-Bank סנדבוקס",
    mode: "PSD2",
    site: "www.fibi.co.il",
    image: "https://www.fibi.co.il/media/uzcoaege/logo-ubank.png",
    isFake: "true",
    psd2Uris: {
      cardUri: "https://api.test.fibi.co.il/psd2/v1.7.0",
      loanUri: "https://api.test.fibi.co.il/psd2/v1.4.0",
      savingsUri: "https://api.test.fibi.co.il/psd2/v1.4.0",
      securitiesUri: "https://api.test.fibi.co.il/psd2/v1",
      tokenUri: "https://api.test.fibi.co.il/fibi/sb/oauth2/token",
      baseUri: "https://api.test.fibi.co.il/psd2/v1.7.0",
    },
    psuIdTypes: [
      {
        name: "U-Bank",
        nameNativeLanguage: "U-Bank",
        id: "FIBI-UBANK",
      },
    ],
    psuIdDefaultType: "FIBI-UBANK",
    type: "BANK",
    status: {
      consents: {
        enabled: true,
      },
      payments: {
        enabled: true,
      },
    },
    successRate: {
      consents: 100,
      payments: 100,
    },
  },
  {
    providerFriendlyId: "ubank",
    name: "U-Bank",
    nameNativeLanguage: "U-Bank",
    mode: "PSD2",
    site: "www.fibi.co.il",
    image: "https://www.fibi.co.il/media/uzcoaege/logo-ubank.png",
    psd2Uris: {
      cardUri: "https://api.ob.fibi.co.il/psd2/v1.7.0",
      loanUri: "https://api.ob.fibi.co.il/psd2/v1.4.0",
      savingsUri: "https://api.ob.fibi.co.il/psd2/v1.4.0",
      securitiesUri: "https://api.ob.fibi.co.il/psd2/v1",
      tokenUri: "https://api.ob.fibi.co.il/fibi/prod/oauth2/token",
      baseUri: "https://api.ob.fibi.co.il/psd2/v1.7.0",
    },
    psuIdTypes: [
      {
        name: "U-Bank",
        nameNativeLanguage: "U-Bank",
        id: "FIBI-UBANK",
      },
    ],
    psuIdDefaultType: "FIBI-UBANK",
    type: "BANK",
    status: {
      consents: {
        enabled: true,
      },
      payments: {
        enabled: true,
      },
    },
    successRate: {
      consents: 100,
      payments: 100,
    },
  },
  {
    providerFriendlyId: "pepper",
    name: "Pepper",
    nameNativeLanguage: "פפר",
    mode: "PSD2",
    site: "www.pepper.co.il",
    image:
      "https://open-finance-assets.s3.eu-west-1.amazonaws.com/providers-logos/pepper.jpeg",
    psd2Uris: {
      cardUri: "https://pepperopenbanking.co.il/prd/v1.7",
      loanUri: "https://pepperopenbanking.co.il/prd/v1.4",
      savingsUri: "https://pepperopenbanking.co.il/prd/v1.4",
      securitiesUri: "https://pepperopenbanking.co.il/prd/v1.0",
      tokenUri: "https://pepperopenbanking.co.il/prd/v1/token",
      baseUri: "https://pepperopenbanking.co.il/prd/v1.7",
    },
    psuIdTypes: [
      {
        name: "Pepper",
        nameNativeLanguage: "פפר",
        id: "Pepper",
      },
    ],
    psuIdDefaultType: "Pepper",
    type: "BANK",
    status: {
      consents: {
        enabled: true,
      },
      payments: {
        enabled: true,
      },
    },
    successRate: {
      consents: 100,
      payments: 100,
    },
  },
  {
    providerFriendlyId: "pagi-sandbox",
    name: "Bank Pagi Sandbox",
    nameNativeLanguage: "בנק פאגי סנדבוקס",
    mode: "PSD2",
    site: "www.fibi.co.il",
    image:
      "https://open-finance-assets.s3.eu-west-1.amazonaws.com/providers-logos/pagi.webp",
    isFake: "true",
    psd2Uris: {
      cardUri: "https://api.test.fibi.co.il/psd2/v1.7.0",
      loanUri: "https://api.test.fibi.co.il/psd2/v1.4.0",
      savingsUri: "https://api.test.fibi.co.il/psd2/v1.4.0",
      securitiesUri: "https://api.test.fibi.co.il/psd2/v1",
      tokenUri: "https://api.test.fibi.co.il/fibi/sb/oauth2/token",
      baseUri: "https://api.test.fibi.co.il/psd2/v1.7.0",
    },
    psuIdTypes: [
      {
        name: "Bank Pagi",
        nameNativeLanguage: "בנק פאגי",
        id: "FIBI-PAGI",
      },
    ],
    psuIdDefaultType: "FIBI-PAGI",
    type: "BANK",
    status: {
      consents: {
        enabled: true,
      },
      payments: {
        enabled: true,
      },
    },
    successRate: {
      consents: 100,
      payments: 100,
    },
  },
  {
    providerFriendlyId: "pagi",
    name: "Bank Pagi",
    nameNativeLanguage: "בנק פאגי",
    mode: "PSD2",
    site: "www.fibi.co.il",
    image:
      "https://open-finance-assets.s3.eu-west-1.amazonaws.com/providers-logos/pagi.webp",
    psd2Uris: {
      cardUri: "https://api.ob.fibi.co.il/psd2/v1.7.0",
      loanUri: "https://api.ob.fibi.co.il/psd2/v1.4.0",
      savingsUri: "https://api.ob.fibi.co.il/psd2/v1.4.0",
      securitiesUri: "https://api.ob.fibi.co.il/psd2/v1",
      tokenUri: "https://api.ob.fibi.co.il/fibi/prod/oauth2/token",
      baseUri: "https://api.ob.fibi.co.il/psd2/v1.7.0",
    },
    psuIdTypes: [
      {
        name: "Bank Pagi",
        nameNativeLanguage: "בנק פאגי",
        id: "FIBI-PAGI",
      },
    ],
    psuIdDefaultType: "FIBI-PAGI",
    type: "BANK",
    status: {
      consents: {
        enabled: true,
      },
      payments: {
        enabled: true,
      },
    },
    successRate: {
      consents: 100,
      payments: 100,
    },
  },
  {
    providerFriendlyId: "otsarHahayal-sandbox",
    name: "Bank Otzar Hahayal Sandbox",
    nameNativeLanguage: "בנק אוצר החייל סנדבוקס",
    mode: "PSD2",
    site: "www.fibi.co.il",
    image: "https://www.bankotsar.co.il/media/zsrdgl4i/logos_rgb_09.png",
    isFake: "true",
    psd2Uris: {
      cardUri: "https://api.test.fibi.co.il/psd2/v1.7.0",
      loanUri: "https://api.test.fibi.co.il/psd2/v1.4.0",
      savingsUri: "https://api.test.fibi.co.il/psd2/v1.4.0",
      securitiesUri: "https://api.test.fibi.co.il/psd2/v1",
      tokenUri: "https://api.test.fibi.co.il/fibi/sb/oauth2/token",
      baseUri: "https://api.test.fibi.co.il/psd2/v1.7.0",
    },
    psuIdTypes: [
      {
        name: "Bank Otzar Hahayal",
        nameNativeLanguage: "בנק אוצר החייל",
        id: "FIBI-OTZAR",
      },
    ],
    psuIdDefaultType: "FIBI-OTZAR",
    type: "BANK",
    status: {
      consents: {
        enabled: true,
      },
      payments: {
        enabled: true,
      },
    },
    successRate: {
      consents: 100,
      payments: 100,
    },
  },
  {
    providerFriendlyId: "otsarHahayal",
    name: "Bank Otzar Hahayal",
    nameNativeLanguage: "בנק אוצר החייל",
    mode: "PSD2",
    site: "www.fibi.co.il",
    image: "https://www.bankotsar.co.il/media/zsrdgl4i/logos_rgb_09.png",
    psd2Uris: {
      cardUri: "https://api.ob.fibi.co.il/psd2/v1.7.0",
      loanUri: "https://api.ob.fibi.co.il/psd2/v1.4.0",
      savingsUri: "https://api.ob.fibi.co.il/psd2/v1.4.0",
      securitiesUri: "https://api.ob.fibi.co.il/psd2/v1",
      tokenUri: "https://api.ob.fibi.co.il/fibi/prod/oauth2/token",
      baseUri: "https://api.ob.fibi.co.il/psd2/v1.7.0",
    },
    psuIdTypes: [
      {
        name: "Bank Otzar Hahayal",
        nameNativeLanguage: "בנק אוצר החייל",
        id: "FIBI-OTZAR",
      },
    ],
    psuIdDefaultType: "FIBI-OTZAR",
    type: "BANK",
    status: {
      consents: {
        enabled: true,
      },
      payments: {
        enabled: true,
      },
    },
    successRate: {
      consents: 100,
      payments: 100,
    },
  },
  {
    providerFriendlyId: "openFinanceBank",
    name: "Open Finance Bank",
    nameNativeLanguage: "אופן פיננס בנק",
    mode: "PSD2",
    site: "www.open-finance.ai",
    image:
      "https://open-finance-media.s3.eu-central-1.amazonaws.com/logos/transparent-logo-black.png",
    isFake: true,
    psd2Uris: {
      tokenUri: "http://localhost:2021/authorize",
      baseUri: "http://localhost:2021/v1.0.6",
    },
    type: "BANK",
  },
  {
    providerFriendlyId: "open-finance-sandbox",
    name: "Open Finance Sandbox",
    nameNativeLanguage: "אופן פיננס סנדבוקס",
    mode: "PSD2",
    site: "www.open-finance.ai",
    image:
      "https://open-finance-media.s3.eu-central-1.amazonaws.com/logos/transparent-logo-black.png",
    isFake: true,
    psd2Uris: {
      tokenUri: "http://localhost:2021/authorize",
      baseUri: "http://localhost:2021/v1.0.6",
    },
    type: "BANK",
    status: {
      consents: {
        enabled: true,
      },
      payments: {
        enabled: true,
      },
    },
    successRate: {
      consents: 100,
      payments: 100,
    },
  },
  {
    providerFriendlyId: "open-finance-card-sandbox",
    name: "Open Finance Sandbox",
    nameNativeLanguage: "אופן פיננס סנדבוקס",
    mode: "PSD2",
    site: "www.open-finance.ai",
    image:
      "https://open-finance-media.s3.eu-central-1.amazonaws.com/logos/transparent-logo-black.png",
    isFake: true,
    psd2Uris: {
      tokenUri: "http://localhost:2021/authorize",
      baseUri: "http://localhost:2021/v1.0.6",
    },
    type: "CARD",
    status: {
      consents: {
        enabled: true,
      },
      payments: {
        enabled: true,
      },
    },
    successRate: {
      consents: 100,
      payments: 100,
    },
  },
  {
    providerFriendlyId: "mizrahi-sandbox",
    name: "Mizrahi-Tefahot Sandbox",
    nameNativeLanguage: "מזרחי-טפחות סנדבוקס",
    mode: "PSD2",
    site: "www.mizrahi-tefahot.co.il",
    image:
      "https://open-finance-assets.s3.eu-west-1.amazonaws.com/providers-logos/mizrahi.svg",
    isFake: true,
    psd2Uris: {
      cardUri: "https://sboapi.mizrahi-tefahot.co.il/psd2/v1.7",
      loanUri: "https://sboapi.mizrahi-tefahot.co.il/psd2/v1.4",
      savingsUri: "https://sboapi.mizrahi-tefahot.co.il/psd2/v1.4",
      securitiesUri: "https://sboapi.mizrahi-tefahot.co.il/psd2/v1.0",
      tokenUri:
        "https://sboapi.mizrahi-tefahot.co.il/accesscodeoauthprovider/v1.7.0/oauth2/token",
      baseUri: "https://sboapi.mizrahi-tefahot.co.il/psd2/v1.7",
    },
    type: "BANK",
    status: {
      consents: {
        enabled: true,
      },
      payments: {
        enabled: true,
      },
    },
    successRate: {
      consents: 100,
      payments: 100,
    },
  },
  {
    providerFriendlyId: "mizrahi",
    name: "Mizrahi-Tefahot",
    nameNativeLanguage: "מזרחי-טפחות",
    mode: "PSD2",
    site: "www.mizrahi-tefahot.co.il",
    image:
      "https://open-finance-assets.s3.eu-west-1.amazonaws.com/providers-logos/mizrahi.svg",
    isFake: false,
    psd2Uris: {
      cardUri: "https://oapi.mizrahi-tefahot.co.il/psd2/v1.7",
      loanUri: "https://oapi.mizrahi-tefahot.co.il/psd2/v1.4",
      savingsUri: "https://oapi.mizrahi-tefahot.co.il/psd2/v1.4",
      securitiesUri: "https://oapi.mizrahi-tefahot.co.il/psd2/v1.0",
      tokenUri:
        "https://oapi.mizrahi-tefahot.co.il/accesscodeoauthprovider/v1.7.0/oauth2/token",
      baseUri: "https://oapi.mizrahi-tefahot.co.il/psd2/v1.7",
    },
    type: "BANK",
    status: {
      consents: {
        enabled: true,
      },
      payments: {
        enabled: true,
      },
    },
    successRate: {
      consents: 100,
      payments: 100,
    },
  },
  {
    providerFriendlyId: "mercantile-sandbox",
    name: "Mercantile Sandbox",
    nameNativeLanguage: "מרכנתיל סנדבוקס",
    mode: "PSD2",
    site: "www.mercantile.co.il",
    image:
      "https://open-finance-assets.s3.eu-west-1.amazonaws.com/providers-logos/marcentil.jpeg",
    isFake: true,
    psd2Uris: {
      cardUri:
        "https://mtls-api-nonprod.mercantile.co.il/devapi/cert/psd2/v1.7",
      loanUri:
        "https://mtls-api-nonprod.mercantile.co.il/devapi/cert/psd2/v1.4",
      savingsUri:
        "https://mtls-api-nonprod.mercantile.co.il/devapi/cert/psd2/v1.4",
      securitiesUri:
        "https://mtls-api-nonprod.mercantile.co.il/devapi/cert/psd2/v1.0",
      tokenUri:
        "https://mtls-api-nonprod.mercantile.co.il/devapi/cert/psd2/v1.0.6/consent/token",
      baseUri:
        "https://mtls-api-nonprod.mercantile.co.il/devapi/cert/psd2/v1.7",
    },
    psuIdTypes: [
      {
        name: "Private Account",
        nameNativeLanguage: "חשבון פרטי",
        id: "Retail",
      },
      {
        name: "Business Account",
        nameNativeLanguage: "חשבון עסקי",
        id: "SME",
      },
    ],
    psuIdDefaultType: "Retail",
    type: "BANK",
    status: {
      consents: {
        enabled: true,
      },
      payments: {
        enabled: true,
      },
    },
    successRate: {
      consents: 100,
      payments: 100,
    },
  },
  {
    providerFriendlyId: "mercantile",
    name: "Mercantile",
    nameNativeLanguage: "מרכנתיל",
    mode: "PSD2",
    site: "www.mercantile.co.il",
    image:
      "https://open-finance-assets.s3.eu-west-1.amazonaws.com/providers-logos/marcentil.jpeg",
    isFake: false,
    psd2Uris: {
      cardUri: "https://mtls-api.mercantile.co.il/prod/d/psd2/v1.7",
      loanUri: "https://mtls-api.mercantile.co.il/prod/d/psd2/v1.4",
      savingsUri: "https://mtls-api.mercantile.co.il/prod/d/psd2/v1.4",
      securitiesUri: "https://mtls-api.mercantile.co.il/prod/d/psd2/v1.0",
      tokenUri:
        "https://mtls-api.mercantile.co.il/prod/d/psd2/v1.0.6/consent/token",
      baseUri: "https://mtls-api.mercantile.co.il/prod/d/psd2/v1.7",
    },
    psuIdTypes: [
      {
        name: "Private Account",
        nameNativeLanguage: "חשבון פרטי",
        id: "Retail",
      },
      {
        name: "Business Account",
        nameNativeLanguage: "חשבון עסקי",
        id: "SME",
      },
    ],
    psuIdDefaultType: "Retail",
    type: "BANK",
    status: {
      consents: {
        enabled: true,
      },
      payments: {
        enabled: true,
      },
    },
    successRate: {
      consents: 100,
      payments: 100,
    },
    allowPsuCorporateIdTypeChoice: true,
    psuCorporateIdTypes: [
      {
        name: "Company",
        nameNativeLanguage: "חברה",
        id: "Company",
      },
      {
        name: "Statutory Without ID",
        nameNativeLanguage: "Statutory Without ID",
        id: "StatutoryWithoutID",
      },
      {
        name: "Foreign Company",
        nameNativeLanguage: "חברה זרה",
        id: "ForeignCompany",
      },
    ],
  },
  {
    providerFriendlyId: "menora-sandbox",
    name: "Menora Sandbox",
    nameNativeLanguage: "מנורה סנדבןקס",
    mode: "PSD2",
    site: "https://www.menoramivt.co.il/",
    image:
      "https://www.pc.co.il/wp-content/uploads/2023/08/%D7%9E%D7%A0%D7%95%D7%A8%D7%94.jpg",
    isFake: "true",
    psd2Uris: {
      loanUri: "https:///open-finance-sandbox.menora.co.il/v1.4",
      tokenUri: "https:///open-finance-sandbox.menora.co.il/v1.7/token",
      baseUri: "https:///open-finance-sandbox.menora.co.il/v1.7",
    },
    type: "BANK",
  },
  {
    providerFriendlyId: "max-sandbox",
    name: "Max Sandbox",
    nameNativeLanguage: "מקס סנדבוקס",
    mode: "PSD2",
    site: "www.max.co.il",
    image:
      "https://open-finance-assets.s3.eu-west-1.amazonaws.com/providers-logos/max.jpeg",
    isFake: true,
    psd2Uris: {
      cardUri: "https://api-ob.max.co.il/max/openbanking/obcards/v1.7",
      loanUri: "https://api-ob.max.co.il/max/openbanking/obconsent/v1.4",
      savingsUri: "https://api-ob.max.co.il/max/openbanking/obconsent/v1.4",
      tokenUri: "https://api-ob.max.co.il/max/openbanking/obconsent/v1.5.0",
      baseUri: "https://api-ob.max.co.il/max/openbanking/obconsent/v1.7",
    },
    psuIdTypes: [
      {
        name: "Private Account",
        nameNativeLanguage: "חשבון פרטי",
        id: "Private",
      },
      {
        name: "Business Account",
        nameNativeLanguage: "חשבון עסקי",
        id: "Business",
      },
    ],
    psuIdDefaultType: "Private",
    type: "CARD",
    status: {
      consents: {
        enabled: true,
      },
      payments: {
        enabled: true,
      },
    },
    successRate: {
      consents: 100,
      payments: 100,
    },
  },
  {
    providerFriendlyId: "max",
    name: "Max",
    nameNativeLanguage: "מקס",
    mode: "PSD2",
    site: "www.max.co.il",
    image:
      "https://open-finance-assets.s3.eu-west-1.amazonaws.com/providers-logos/max.jpeg",
    psd2Uris: {
      cardUri: "https://api-ob.max.co.il/max/openbanking/obcards/v1.7.0",
      loanUri: "https://api-ob.max.co.il/max/openbanking/obloans/v1.4.0",
      savingsUri: "https://api-ob.max.co.il/max/openbanking/obconsent/v1.4.0",
      tokenUri:
        "https://api-ob.max.co.il/max/openbanking/obauthorizationapi/oauth2/token",
      baseUri: "https://api-ob.max.co.il/max/openbanking/obconsent/v1.7.0",
    },
    psuIdTypes: [
      {
        name: "Private Account",
        nameNativeLanguage: "חשבון פרטי",
        id: "Private",
      },
      {
        name: "Business Account",
        nameNativeLanguage: "חשבון עסקי",
        id: "Business",
      },
    ],
    psuIdDefaultType: "Private",
    type: "CARD",
    status: {
      consents: {
        enabled: true,
      },
      payments: {
        enabled: true,
      },
    },
    successRate: {
      consents: 100,
      payments: 100,
    },
  },
  {
    providerFriendlyId: "masad-sandbox",
    name: "Bank Massad Sandbox",
    nameNativeLanguage: "בנק מסד סנדבוקס",
    mode: "PSD2",
    site: "www.fibi.co.il",
    image: "https://www.bankmassad.co.il/media/4rvfo312/logo-header-1.png",
    isFake: "true",
    psd2Uris: {
      cardUri: "https://api.test.fibi.co.il/psd2/v1.7.0",
      loanUri: "https://api.test.fibi.co.il/psd2/v1.4.0",
      savingsUri: "https://api.test.fibi.co.il/psd2/v1.4.0",
      securitiesUri: "https://api.test.fibi.co.il/psd2/v1",
      tokenUri: "https://api.test.fibi.co.il/fibi/sb/oauth2/token",
      baseUri: "https://api.test.fibi.co.il/psd2/v1.7.0",
    },
    psuIdTypes: [
      {
        name: "Bank Massad",
        nameNativeLanguage: "בנק מסד",
        id: "MASSAD",
      },
    ],
    psuIdDefaultType: "MASSAD",
    type: "BANK",
    status: {
      consents: {
        enabled: true,
      },
      payments: {
        enabled: true,
      },
    },
    successRate: {
      consents: 100,
      payments: 100,
    },
  },
  {
    providerFriendlyId: "masad",
    name: "Bank Massad",
    nameNativeLanguage: "בנק מסד",
    mode: "PSD2",
    site: "www.fibi.co.il",
    image: "https://www.bankmassad.co.il/media/4rvfo312/logo-header-1.png",
    psd2Uris: {
      cardUri: "https://api.ob.fibi.co.il/psd2/v1.7.0",
      loanUri: "https://api.ob.fibi.co.il/psd2/v1.4.0",
      savingsUri: "https://api.ob.fibi.co.il/psd2/v1.4.0",
      securitiesUri: "https://api.ob.fibi.co.il/psd2/v1",
      tokenUri: "https://api.ob.fibi.co.il/fibi/prod/oauth2/token",
      baseUri: "https://api.ob.fibi.co.il/psd2/v1.7.0",
    },
    psuIdTypes: [
      {
        name: "Bank Massad",
        nameNativeLanguage: "בנק מסד",
        id: "MASSAD",
      },
    ],
    psuIdDefaultType: "MASSAD",
    type: "BANK",
    status: {
      consents: {
        enabled: true,
      },
      payments: {
        enabled: true,
      },
    },
    successRate: {
      consents: 100,
      payments: 100,
    },
  },
  {
    providerFriendlyId: "leumi-sandbox",
    name: "Leumi Sandbox",
    nameNativeLanguage: "לאומי סנדבוקס",
    mode: "PSD2",
    site: "www.leumi.co.il",
    image:
      "https://open-finance-assets.s3.eu-west-1.amazonaws.com/providers-logos/leumi.png",
    isFake: true,
    psd2Uris: {
      cardUri: "https://api.sbxleumiob.co.il/dev/sandbox/v1.7",
      loanUri: "https://api.sbxleumiob.co.il/dev/sandbox/v1.4",
      savingsUri: "https://api.sbxleumiob.co.il/dev/sandbox/v1.4",
      securitiesUri: "https://api.sbxleumiob.co.il/dev/sandbox/v1.0",
      tokenUri: "https://api.sbxleumiob.co.il/dev/sandbox/v1.7/token",
      baseUri: "https://api.sbxleumiob.co.il/dev/sandbox/v1.7",
    },
    psuIdTypes: [
      {
        name: "Private Account",
        nameNativeLanguage: "חשבון פרטי",
        id: "leumi",
      },
    ],
    psuIdDefaultType: "leumi",
    type: "BANK",
    status: {
      consents: {
        enabled: true,
      },
      payments: {
        enabled: true,
      },
    },
    successRate: {
      consents: 100,
      payments: 100,
    },
  },
  {
    providerFriendlyId: "leumi",
    name: "Leumi",
    nameNativeLanguage: "לאומי",
    mode: "PSD2",
    site: "www.leumi.co.il",
    image:
      "https://open-finance-assets.s3.eu-west-1.amazonaws.com/providers-logos/leumi.png",
    psd2Uris: {
      cardUri: "https://leumiopenbanking.co.il/prd/v1.7",
      loanUri: "https://leumiopenbanking.co.il/prd/v1.4",
      savingsUri: "https://leumiopenbanking.co.il/prd/v1.4",
      securitiesUri: "https://leumiopenbanking.co.il/prd/v1.0",
      tokenUri: "https://leumiopenbanking.co.il/prd/v1/token",
      baseUri: "https://leumiopenbanking.co.il/prd/v1.7",
    },
    psuIdTypes: [
      {
        name: "Private Account",
        nameNativeLanguage: "חשבון פרטי",
        id: "leumi",
      },
    ],
    psuIdDefaultType: "leumi",
    type: "BANK",
    status: {
      consents: {
        enabled: true,
      },
      payments: {
        enabled: true,
      },
    },
    successRate: {
      consents: 100,
      payments: 100,
    },
  },
  {
    providerFriendlyId: "isracard-sandbox",
    name: "Isracard Sandbox",
    nameNativeLanguage: "ישראכרט סנדבוקס",
    mode: "PSD2",
    site: "www.isracard.co.il",
    image:
      "https://open-finance-assets.s3.eu-west-1.amazonaws.com/providers-logos/isracard.jpeg",
    isFake: "true",
    psd2Uris: {
      cardUri: "https://sbob.api.isracard.co.il/v1.7",
      loanUri: "https://sbob.api.isracard.co.il/v1",
      savingsUri: "https://sbob.api.isracard.co.il/v1",
      tokenUri: "https://sbob.api.isracard.co.il/v1.5.0",
      baseUri: "https://sbob.api.isracard.co.il/v1.7",
    },
    psuIdTypes: [
      {
        name: "Isracard",
        nameNativeLanguage: "ישראכרט",
        id: "Isracard",
      },
      {
        name: "American Express",
        nameNativeLanguage: "אמריקן אקספרס",
        id: "AmericanExpress",
      },
    ],
    psuIdDefaultType: "Isracard",
    type: "CARD",
    status: {
      consents: {
        enabled: true,
      },
      payments: {
        enabled: true,
      },
    },
    successRate: {
      consents: 100,
      payments: 100,
    },
  },
  {
    providerFriendlyId: "isracard",
    name: "Isracard",
    nameNativeLanguage: "ישראכרט",
    mode: "PSD2",
    site: "www.isracard.co.il",
    image:
      "https://open-finance-assets.s3.eu-west-1.amazonaws.com/providers-logos/isracard.jpeg",
    psd2Uris: {
      cardUri: "https://ob.api.isracard.co.il/v1.7",
      loanUri: "https://ob.api.isracard.co.il/v1",
      savingsUri: "https://ob.api.isracard.co.il/v1",
      tokenUri: "https://ob.api.isracard.co.il/oauthproxy/token",
      baseUri: "https://ob.api.isracard.co.il/v1.7",
    },
    psuIdTypes: [
      {
        name: "Isracard",
        nameNativeLanguage: "ישראכרט",
        id: "Isracard",
      },
      {
        name: "American Express",
        nameNativeLanguage: "אמריקן אקספרס",
        id: "AmericanExpress",
      },
    ],
    psuIdDefaultType: "Isracard",
    type: "CARD",
    status: {
      consents: {
        enabled: true,
      },
      payments: {
        enabled: true,
      },
    },
    successRate: {
      consents: 100,
      payments: 100,
    },
  },
  {
    providerFriendlyId: "hapoalim-sandbox",
    name: "Hapoalim Sandbox",
    nameNativeLanguage: "הפועלים סנדבוקס",
    mode: "PSD2",
    site: "www.bankhapoalim.co.il",
    image:
      "https://open-finance-assets.s3.eu-west-1.amazonaws.com/providers-logos/hapolim.jpeg",
    isFake: true,
    psd2Uris: {
      cardUri: "https://openbankingsb.poalim-api.co.il/xs2a/unpr/v1.7",
      loanUri: "https://openbankingsb.poalim-api.co.il/xs2a/unpr/v1.4",
      savingsUri: "https://openbankingsb.poalim-api.co.il/xs2a/unpr/v1.4",
      tokenUri:
        "https://openbankingsb.poalim-api.co.il/xs2a/unpr/oauth2/v1/token",
      baseUri: "https://openbankingsb.poalim-api.co.il/xs2a/unpr/v1.7",
    },
    psuIdTypes: [
      {
        name: "Private Account",
        nameNativeLanguage: "חשבון פרטי",
        id: "privateBankCustomers",
      },
      {
        name: "Business Account",
        nameNativeLanguage: "חשבון עסקי",
        id: "corporateBankCustomers",
      },
    ],
    psuIdDefaultType: "privateBankCustomers",
    type: "BANK",
    status: {
      consents: {
        enabled: true,
      },
      payments: {
        enabled: true,
      },
    },
    successRate: {
      consents: 100,
      payments: 100,
    },
  },
  {
    providerFriendlyId: "hapoalim",
    name: "Hapoalim",
    nameNativeLanguage: "הפועלים",
    mode: "PSD2",
    site: "www.bankhapoalim.co.il",
    image:
      "https://open-finance-assets.s3.eu-west-1.amazonaws.com/providers-logos/hapolim.jpeg",
    psd2Uris: {
      paymentsUri:
        "https://openbanking.poalim-api.co.il/xs2a/unpr/payment-data/v1.7",
      securitiesUri:
        "https://openbanking.poalim-api.co.il/xs2a/unpr/securities-accounts/v1.0",
      tokenUri:
        "https://openbanking.poalim-api.co.il/xs2a/unpr/oauth2/v1/token",
      baseUri: "https://openbanking.poalim-api.co.il/xs2a/unpr/v1.7",
      cardUri: "https://openbanking.poalim-api.co.il/xs2a/unpr/cards-data/v1.7",
      loanUri:
        "https://openbanking.poalim-api.co.il/xs2a/unpr/savings-loans/v1.4",
      savingsUri:
        "https://openbanking.poalim-api.co.il/xs2a/unpr/savings-loans/v1.4",
    },
    psuIdTypes: [
      {
        name: "Private Account",
        nameNativeLanguage: "חשבון פרטי",
        id: "privateBankCustomers",
      },
      {
        name: "Business Account",
        nameNativeLanguage: "חשבון עסקי",
        id: "corporateBankCustomers",
      },
    ],
    psuIdDefaultType: "privateBankCustomers",
    type: "BANK",
    status: {
      consents: {
        enabled: true,
      },
      payments: {
        enabled: true,
      },
    },
    successRate: {
      consents: 100,
      payments: 100,
    },
  },
  {
    providerFriendlyId: "discount-sandbox",
    name: "Discount Sandbox",
    nameNativeLanguage: "דיסקונט סנדבוקס",
    mode: "PSD2",
    site: "www.discount.co.il",
    image:
      "https://open-finance-assets.s3.eu-west-1.amazonaws.com/providers-logos/discount.jpeg",
    isFake: true,
    psd2Uris: {
      cardUri:
        "https://mtls-api-nonprod.discountbank.co.il/devapi/cert/psd2/v1.7",
      loanUri:
        "https://mtls-api-nonprod.discountbank.co.il/devapi/cert/psd2/v1.4",
      savingsUri:
        "https://mtls-api-nonprod.discountbank.co.il/devapi/cert/psd2/v1.4",
      securitiesUri:
        "https://mtls-api-nonprod.discountbank.co.il/devapi/cert/psd2/v1.0",
      tokenUri:
        "https://mtls-api-nonprod.discountbank.co.il/devapi/cert/psd2/v1.0.6/consent/token",
      baseUri:
        "https://mtls-api-nonprod.discountbank.co.il/devapi/cert/psd2/v1.7",
    },
    psuIdTypes: [
      {
        name: "Private Account",
        nameNativeLanguage: "חשבון פרטי",
        id: "Retail",
      },
      {
        name: "Business Account",
        nameNativeLanguage: "חשבון עסקי",
        id: "SME",
      },
    ],
    psuIdDefaultType: "Retail",
    type: "BANK",
    status: {
      consents: {
        enabled: true,
      },
      payments: {
        enabled: true,
      },
    },
    successRate: {
      consents: 100,
      payments: 100,
    },
  },
  {
    providerFriendlyId: "discount",
    name: "Discount",
    nameNativeLanguage: "דיסקונט",
    mode: "PSD2",
    site: "www.discount.co.il",
    image:
      "https://open-finance-assets.s3.eu-west-1.amazonaws.com/providers-logos/discount.jpeg",
    isFake: false,
    psd2Uris: {
      cardUri: "https://mtls-api.discountbank.co.il/prod/d/psd2/v1.7",
      loanUri: "https://mtls-api.discountbank.co.il/prod/d/psd2/v1.4",
      savingsUri: "https://mtls-api.discountbank.co.il/prod/d/psd2/v1.4",
      securitiesUri: "https://mtls-api.discountbank.co.il/prod/d/psd2/v1.0",
      tokenUri:
        "https://mtls-api.discountbank.co.il/prod/d/psd2/v1.0.6/consent/token",
      baseUri: "https://mtls-api.discountbank.co.il/prod/d/psd2/v1.7",
    },
    psuIdTypes: [
      {
        name: "Private Account",
        nameNativeLanguage: "חשבון פרטי",
        id: "Retail",
      },
      {
        name: "Business Account",
        nameNativeLanguage: "חשבון עסקי",
        id: "SME",
      },
    ],
    psuIdDefaultType: "Retail",
    type: "BANK",
    status: {
      consents: {
        enabled: true,
      },
      payments: {
        enabled: true,
      },
    },
    successRate: {
      consents: 100,
      payments: 100,
    },
    allowPsuCorporateIdTypeChoice: true,
    psuCorporateIdTypes: [
      {
        name: "Company",
        nameNativeLanguage: "חברה",
        id: "Company",
      },
      {
        name: "Statutory Without ID",
        nameNativeLanguage: "Statutory Without ID",
        id: "StatutoryWithoutID",
      },
      {
        name: "Foreign Company",
        nameNativeLanguage: "חברה זרה",
        id: "ForeignCompany",
      },
    ],
  },
  {
    providerFriendlyId: "cal-sandbox",
    name: "Cal Sandbox",
    nameNativeLanguage: "ויזה כאל סנדבוקס",
    mode: "PSD2",
    site: "www.cal-online.co.il",
    image:
      "https://open-finance-assets.s3.eu-west-1.amazonaws.com/providers-logos/visa-cal.jpeg",
    isFake: true,
    psd2Uris: {
      cardUri: "https://api-sbx-cc.cal-online.co.il/v1.7.0",
      loanUri: "https://api-sbx-cc.cal-online.co.il/v1.4.0",
      savingsUri: "https://api-sbx-cc.cal-online.co.il/v1.4.0",
      tokenUri: "https://api-sbx-cc.cal-online.co.il/v1.5.0",
      baseUri: "https://api-sbx-cc.cal-online.co.il/v1.7.0",
    },
    psuIdTypes: [
      {
        name: "Private",
        nameNativeLanguage: "חשבון פרטי",
        id: "private",
      },
      {
        name: "Business",
        nameNativeLanguage: "חשבון עסקי",
        id: "business",
      },
    ],
    psuIdDefaultType: "private",
    type: "CARD",
    status: {
      consents: {
        enabled: true,
      },
      payments: {
        enabled: true,
      },
    },
    successRate: {
      consents: 100,
      payments: 100,
    },
  },
  {
    providerFriendlyId: "cal",
    name: "Cal",
    nameNativeLanguage: "ויזה כאל",
    mode: "PSD2",
    site: "www.cal-online.co.il",
    image:
      "https://open-finance-assets.s3.eu-west-1.amazonaws.com/providers-logos/visa-cal.jpeg",
    psd2Uris: {
      cardUri: "https://api-cc.cal-online.co.il/v1.7.0",
      loanUri: "https://api-cc.cal-online.co.il/v1.4.0",
      savingsUri: "https://api-cc.cal-online.co.il/v1.4.0",
      tokenUri: "https://api-cc.cal-online.co.il/oauth/token",
      baseUri: "https://api-cc.cal-online.co.il/v1.7.0",
    },
    psuIdTypes: [
      {
        name: "Private",
        nameNativeLanguage: "חשבון פרטי",
        id: "private",
      },
      {
        name: "Business",
        nameNativeLanguage: "חשבון עסקי",
        id: "business",
      },
    ],
    psuIdDefaultType: "private",
    type: "CARD",
    status: {
      consents: {
        enabled: true,
      },
      payments: {
        enabled: true,
      },
    },
    successRate: {
      consents: 100,
      payments: 100,
    },
  },
  {
    providerFriendlyId: "beinleumi-sandbox",
    name: "Beinleumi Sandbox",
    nameNativeLanguage: "בנק הבינלאומי סנדבוקס",
    mode: "PSD2",
    site: "www.fibi.co.il",
    image:
      "https://open-finance-assets.s3.eu-west-1.amazonaws.com/providers-logos/beinleumi.jpeg",
    isFake: "true",
    psd2Uris: {
      cardUri: "https://api.test.fibi.co.il/psd2/v1.7.0",
      loanUri: "https://api.test.fibi.co.il/psd2/v1.4.0",
      savingsUri: "https://api.test.fibi.co.il/psd2/v1.4.0",
      securitiesUri: "https://api.test.fibi.co.il/psd2/v1",
      tokenUri: "https://api.test.fibi.co.il/fibi/sb/oauth2/token",
      baseUri: "https://api.test.fibi.co.il/psd2/v1.7.0",
    },
    psuIdTypes: [
      {
        name: "Bank Beinleumi",
        nameNativeLanguage: "בנק הבינלאומי",
        id: "FIBI-BNL",
      },
    ],
    psuIdDefaultType: "FIBI-BNL",
    type: "BANK",
    status: {
      consents: {
        enabled: true,
      },
      payments: {
        enabled: true,
      },
    },
    successRate: {
      consents: 100,
      payments: 100,
    },
  },
  {
    providerFriendlyId: "beinleumi",
    name: "Beinleumi",
    nameNativeLanguage: "בנק הבינלאומי",
    mode: "PSD2",
    site: "www.fibi.co.il",
    image:
      "https://open-finance-assets.s3.eu-west-1.amazonaws.com/providers-logos/beinleumi.jpeg",
    psd2Uris: {
      cardUri: "https://api.ob.fibi.co.il/psd2/v1.7.0",
      loanUri: "https://api.ob.fibi.co.il/psd2/v1.4.0",
      savingsUri: "https://api.ob.fibi.co.il/psd2/v1.4.0",
      securitiesUri: "https://api.ob.fibi.co.il/psd2/v1",
      tokenUri: "https://api.ob.fibi.co.il/fibi/prod/oauth2/token",
      baseUri: "https://api.ob.fibi.co.il/psd2/v1.7.0",
    },
    psuIdTypes: [
      {
        name: "Bank Beinleumi",
        nameNativeLanguage: "בנק הבינלאומי",
        id: "FIBI-BNL",
      },
    ],
    psuIdDefaultType: "FIBI-BNL",
    type: "BANK",
    status: {
      consents: {
        enabled: true,
      },
      payments: {
        enabled: true,
      },
    },
    successRate: {
      consents: 100,
      payments: 100,
    },
  },
  {
    providerFriendlyId: "americanExpress",
    name: "American Express",
    nameNativeLanguage: "אמריקן אקספרס",
    mode: "PSD2",
    site: "https://he.americanexpress.co.il",
    image:
      "https://open-finance-assets.s3.eu-west-1.amazonaws.com/providers-logos/americanExpress.png",
    psd2Uris: {
      cardUri: "https://ob.api.isracard.co.il/v1.7",
      loanUri: "https://ob.api.isracard.co.il/v1",
      savingsUri: "https://ob.api.isracard.co.il/v1",
      tokenUri: "https://ob.api.isracard.co.il/oauthproxy/token",
      baseUri: "https://ob.api.isracard.co.il/v1.7",
    },
    psuIdTypes: [
      {
        name: "American Express",
        nameNativeLanguage: "אמריקן אקספרס",
        id: "AmericanExpress",
      },
    ],
    psuIdDefaultType: "AmericanExpress",
    type: "CARD",
    status: {
      consents: {
        enabled: true,
      },
      payments: {
        enabled: true,
      },
    },
    successRate: {
      consents: 100,
      payments: 100,
    },
  },
  {
    providerFriendlyId: "one-zero",
    name: "One Zero Digital Bank",
    nameNativeLanguage: "וואן זירו",
    mode: "PSD2",
    site: "www.onezerobank.com",
    image: "https://www.onezerobank.com/favicon.ico",
    type: "BANK",
    status: {
      consents: {
        enabled: true,
      },
      payments: {
        enabled: false,
      },
    },
    successRate: {
      consents: 100,
      payments: 0,
    },
  },
];

export function getOpenfinanceProviderList(
  includeFakeProviders: boolean = false
) {
  let providerList: string[] = [];
  openfinanceProviders.forEach((provider) => {
    if (includeFakeProviders || !provider.isFake) {
      providerList.push(provider.providerFriendlyId);
    }
  });
  return providerList;
}

export function openFinanceProviderToNativeLanguageName(
  providerFriendlyId: string
) {
  let provider = openfinanceProviders.find(
    (provider) => provider.providerFriendlyId === providerFriendlyId
  );
  if (provider) {
    if (provider.providerFriendlyId === "americanExpress") {
      return "אמקס";
    }
    return `${provider.nameNativeLanguage} `;
  }
  return providerFriendlyId;
}

export function openFinanceProviderToProviderType(providerFriendlyId: string) {
  let provider = openfinanceProviders.find(
    (provider) => provider.providerFriendlyId === providerFriendlyId
  );
  if (provider) {
    return provider.type;
  }
  return "BANK";
}

/** Local logo filenames in /openfinance-logos/ (downloaded from open-finance-assets S3). */
const LOCAL_PROVIDER_LOGOS: Record<string, string> = {
  "one-zero": "one-zero.png",
  pagi: "pagi.webp",
  beinleumi: "beinleumi.jpeg",
  discount: "discount.jpeg",
  hapoalim: "hapolim.jpeg",
  leumi: "leumi.png",
  mercantile: "marcentil.jpeg",
  mizrahi: "mizrahi.svg",
  pepper: "pepper.jpeg",
  yahav: "yahav.jpeg",
  americanExpress: "americanExpress.png",
  cal: "visa-cal.jpeg",
  isracard: "isracard.jpeg",
  max: "max.jpeg",
};

export function getOpenFinanceProviderImageUrl(
  providerFriendlyId: string
): string | undefined {
  const baseId = providerFriendlyId.replace(/-sandbox$/, "");
  const localFile = LOCAL_PROVIDER_LOGOS[baseId];
  if (localFile) return `/openfinance-logos/${localFile}`;
  const provider = openfinanceProviders.find(
    (p) => p.providerFriendlyId === providerFriendlyId
  );
  return provider?.image;
}
